import 'ol/ol.css';
import 'ol-ext/dist/ol-ext.css';
import { GSALayers } from "./gsa/GSALayers";
import { GSAContextManager } from './gsa/GSAContextManager';
import { GSAInteractionManager } from './gsa/GSAInteractionManager';
import { GSAToolbar } from './gsa/GSAToolbar';
import { GSADispatcher } from './gsa/GSADispatcher';
import { BaseLayerBox } from './layerbox/BaseLayerBox';
import { ThematicLayerBox } from './layerbox/ThematicLayerBox';
import { OverlayLayerBox } from './layerbox/OverlayLayerBox';
import { GSAMap } from './gsa/GSAMap';
import { CloseMessage, ReadyMessage } from '../lib/messages';
import $ from 'jquery';
const DEBUG = false;
const debug_setup = (map, p_layer, ctx_mgr, i_mgr) => {
    console.info("Debug enabled. Available: map, parcelLayer, contextManager, interactionManager");
    window.map = map;
    window.parcelLayer = p_layer;
    window.contextManager = ctx_mgr;
    window.interactionManager = i_mgr;
};
document.body.oncontextmenu = (e) => e.preventDefault();
const run = async (view) => {
    const map = await GSAMap.build(Config, view);
    map.add_layerbox_components(new BaseLayerBox({ render_index: 0, ui_index: 0 }), new ThematicLayerBox({ render_index: 1, ui_index: 2 }), new OverlayLayerBox({ render_index: 2, ui_index: 1 }));
    const parcel_layer = GSALayers.parcel(view, GSAMap.config);
    const marker_layer = GSALayers.marker(parcel_layer);
    const sketch_layer = GSALayers.sketch;
    const group_layer = GSALayers.group;
    const measurement_layer = GSALayers.measure;
    const zoombox_layer = GSALayers.zoombox;
    map.add_selection_layer(parcel_layer);
    map.add_client_layers(marker_layer, sketch_layer, group_layer, measurement_layer, zoombox_layer);
    const ctx_manager = new GSAContextManager(map, parcel_layer, marker_layer);
    const interaction_manager = new GSAInteractionManager(map, parcel_layer, sketch_layer);
    const toolbar = new GSAToolbar(parcel_layer);
    map.addControl(toolbar);
    const dispatcher = new GSADispatcher(map, parcel_layer, sketch_layer, marker_layer, ctx_manager);
    if (DEBUG)
        debug_setup(map, parcel_layer, ctx_manager, interaction_manager);
    ctx_manager.update_context('singleton');
    map.ready();
    const map_pointer_handler = (event) => {
        if (event.dragging)
            return;
        const pixel = map.getEventPixel(event.originalEvent);
        let features = map.get_features_at_pixel(pixel);
        let r_features = features.filter(v => v[1] === parcel_layer.raw).map(v => v[0]);
        if (r_features.length === 0) {
            $('#status-content').remove();
            parcel_layer.hovered = '';
            return;
        }
        const f = r_features[0];
        parcel_layer.hovered = f.get(parcel_layer.identifier);
        let content = $('<div id="status-content"></div>');
        if (parcel_layer.colorized) {
            const field = parcel_layer.color_manager.fields.selected.unwrapOr('');
            content.html(`Parcel ${parcel_layer.identifier}: ${parcel_layer.hovered}, ${field}: ${f.get(field)}`);
        }
        else {
            content.html(`Parcel ${parcel_layer.identifier}: ${parcel_layer.hovered}`);
        }
        $('#status-content').remove();
        $('#status-bar').prepend(content);
    };
    const handle_parcel_click = (coord, alt) => {
        ctx_manager.context.map(c => c.click_handler(coord, alt));
    };
    map.on('pointermove', evt => {
        ctx_manager.context
            .filter(c => !c.has_measure || c.name === 'group')
            .mapOr(interaction_manager.pointer_handler(evt), _ => map_pointer_handler(evt));
    });
    map.on('click', (evt) => {
        ctx_manager.context
            .filter(c => !c.has_measure)
            .map(_ => handle_parcel_click(evt.coordinate, evt.originalEvent.shiftKey));
    });
    $(window).on('message', (msg) => {
        const message = msg.originalEvent;
        if (message.data.command !== 'SET VIEW')
            dispatcher.dispatch(message.data);
    }).on('unload', () => {
        CloseMessage.send();
    });
};
window.addEventListener('message', msg => {
    if (msg.data.command === 'SET VIEW') {
        if (window.map)
            delete window.map;
        $('#map').html('<div id="popup"></div>');
        $('#layerbox').html('');
        $('#thematicbox').html('');
        run(msg.data.view);
    }
});
window.onload = () => setTimeout(() => ReadyMessage.send(), 250);
